import { BUILDER_STEP_ORDER } from 'shared/consts';

import type { BuilderStep } from '../types';

/**
 * Returns the next step after `current`, or `null` at the end. Defaults to the
 * full builder order; pass a campaign's navigable order (see `getNavigableSteps`)
 * to skip steps that don't apply — e.g. Fix in no-lookup countries.
 */
export const getNextBuilderStep = (current: BuilderStep, steps: readonly BuilderStep[] = BUILDER_STEP_ORDER) => {
  const index = steps.indexOf(current);

  return steps[index + 1] ?? null;
};
